import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './image/top.png'


const _withScopeId = n => (_pushScopeId("data-v-0707801a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { computed, markRaw, onMounted, onUnmounted, ref, watch } from 'vue';
import HomeVue from './components/Home.vue';
import ProgramVue from './components/Program.vue';
import PartnerVue from './components/Partner.vue';
import ItVue from './components/It.vue';
import PanoramaVue from './components/Panorama.vue'
import IRCameraVue from './components/IRCamera.vue'
import { isPC } from './utils';
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import FooterVue from '@/components/Footer.vue'
import { Pagination } from 'swiper';
import 'swiper/swiper.min.css';


// import required modules


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  activeIndex: Number
},
  emits: ["heightChange", "wheelChange", 'indexChange'],
  setup(__props, { emit: __emit }) {

var debounce = require('lodash.debounce');

const props = __props
const emit = __emit;
/**
 * 实时监控可视范围高度（动态改变每个页的高度）
 */

const rootRef = ref();


const handleChange =(index) => {
  emit('indexChange', index.activeIndex)
}
const swiperInst = ref<any>();
const onSwiper = (s: any) => {
  swiperInst.value = markRaw(s)
}
const handleChangeSwiper = () => {
  console.log(swiperInst)
  swiperInst.value.slideTo(0,200)
}

watch(() => props.activeIndex, (v) => {
  swiperInst.value.slideTo(v,200)
})
const height = ref()
const containerStyle = computed(() => {
  return `height: auto`
})
const handleHeightWatch = (event: any) => {
  height.value = event.currentTarget.innerHeight
  // emit('heightChange', height.value)
}
onMounted(() => {
  // height.value = window.innerHeight
  // emit('heightChange', height.value)
  //window.addEventListener('resize', handleHeightWatch)
})
onUnmounted(() => {
  // window.removeEventListener('resize', handleHeightWatch)
})

/**
 * 鼠标检测上下
 */
/**
 * 检测鼠标向上向下
 */
const handleMouseWheel = debounce((event: any) => {

  const isDown = event.wheelDelta ? event.wheelDelta < 0 : event.detail > 0;
  emit('wheelChange', isDown)
  if (isDown) {
    swiperInst.value.slideNext(300)
  } else {
    swiperInst.value.slidePrev(300)
  }
  event.preventDefault();
}, 200)
onMounted(() => {
  // alert(isPC())
  if (isPC()) {
    document.addEventListener('wheel', handleMouseWheel)

    onUnmounted(() => {
      document.removeEventListener('wheel', handleMouseWheel)
    })
  }
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "index",
    ref_key: "rootRef",
    ref: rootRef
  }, [
    _createVNode(_unref(Swiper), {
      direction: 'vertical',
      modules: [],
      class: "mySwiper",
      resistanceRatio: 0,
      onActiveIndexChange: handleChange,
      onSwiper: onSwiper,
      slidesPerView: 'auto',
      noSwipingClass: "panorama_viewer"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _createVNode(HomeVue, { ref: "home" }, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _createVNode(ProgramVue)
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _createVNode(PanoramaVue)
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _createVNode(IRCameraVue)
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _createVNode(ItVue)
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _createVNode(PartnerVue)
          ]),
          _: 1
        }),
        _createVNode(_unref(SwiperSlide), { class: "index_footer" }, {
          default: _withCtx(() => [
            _createVNode(FooterVue)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (__props.activeIndex !== 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "index_top",
          onClick: handleChangeSwiper
        }, _hoisted_2))
      : _createCommentVNode("", true)
  ], 512))
}
}

})